<template>

    <Head :title="author.name">
        <meta
            type="title"
            :content="author.name"
            head-key="title"
        >
        <meta
            type="description"
            :content="author.name"
            head-key="description"
        >
        <meta
            type="keywords"
            :content="author.name"
            head-key="keywords"
        >
    </Head>

    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-lg-10 offset-lg-2 px-0 px-sm-3 distance-y-container">
                <div class="px-3 padding-y-0-50">
                    <h4 class="mb-3 ff-sans fw-500 fz-40 color-black lh-xs" v-text="author.name"></h4>
                    <p class="ff-sans fw-500 fz-18 color-black lh-xs text-uppercase" v-text="author.category"></p>
                    <div class="site-content link-black ff-sans fw-400 fz-18 color-black lh-sm"
                         v-html="author.description"></div>
                </div>
                <div id="wall" class="w-100">

                    <!-- SPINNER PER CARICAMENTO -->
                    <div v-if="items.length === 0" class="home-spinner-load">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>

                    <div class="grid" style="position: relative" ref="masonry">
                        <div class="grid-sizer"></div>
                        <div v-for="(item, index) in items" class="author-image-wrap grid-item">
                            <a href="#" class="mirror-link" @click.prevent="mirrorClicked(item.id)">
                                <div v-if="item" class="nx-item position-relative">
                                    <img :src="item.thumbnails['720p'].url" :alt="item.alt_text"
                                         :width="item.thumbnails['720p'].width"
                                         :height="item.thumbnails['720p'].height">
                                    <div v-if="item.type === 'video'" class="icon-play-wrap"
                                         style="background-image: url(/client/images/icn_play.png)"></div>
<!--                                    <div
                                        style="position: absolute; width: 100px; height: 100px; background-color: black; color: white; top: 0; left: 0">
                                        {{ item.id }} {{ item.position }}
                                    </div>-->
                                </div>
                            </a>
                            <div v-if="item.caption" class="author-caption-image">
                                <p class="ff-sans fw-400 fz-16-min-14 lh-sm text-center">
                                    {{ item.caption }}
                                </p>
                            </div>
                        </div>

                    </div>

                    <!--                    <MasonryWall v-else :items="items" :column-width="columnWidth" :max-colums="3" :gap="0">
                                            <template #default="{item,index}">
                                                <div class="author-image-wrap">
                                                    <a href="#" class="mirror-link" @click.prevent="mirrorClicked(item.id)">
                                                        <div v-if="item" class="nx-item position-relative">
                                                            <img :src="item.thumbnails['720p'].url" :alt="item.alt_text"
                                                                 :width="item.thumbnails['720p'].width"
                                                                 :height="item.thumbnails['720p'].height">
                                                            <div v-if="item.type === 'video'" class="icon-play-wrap"
                                                                 style="background-image: url(/client/images/icn_play.png)"></div>
                                                            <div
                                                                style="position: absolute; width: 100px; height: 100px; background-color: black; color: white; top: 0; left: 0">
                                                                {{ item.id }} {{ item.position }}
                                                            </div>
                                                        </div>
                                                    </a>
                                                    <div v-if="item.caption" class="author-caption-image">
                                                        <p class="ff-sans fw-400 fz-16-min-14 lh-sm text-center">
                                                            {{ item.caption }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </template>

                                        </MasonryWall>-->


                    <div style="display: none">
                        <a v-for="item of items" :id="getTargetId(item.id)"
                           :href="item.type === 'video' ? item.video_url : item.thumbnails['1080p'].url"
                           data-fancybox="gallery"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import Utils from "../utils/utils";


export default {
    name: "Author",

    props: {
        author: Object,
    },

    data() {
        return {
            items: [],
            meta: null,
            loading: false,
            breakpoints: {
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
                xxl: 1586,
            },
            currentBreakpoint: "sm",
        }
    },

    mounted() {

        this.scroll();

        if (this.shouldLoadItems) {
            this.loadItems(1);
        }

        const instance = this;

        window.onresize = (e) => {
            const screenSize = Utils.getScreenSize();

            const width = screenSize.w;
            instance.onWindowResized(width);
        };
        this.onWindowResized(Utils.getScreenSize().w);

        //this.$nextTick(() => this.masonry());
    },

    updated() {
        //console.log("updated");
        this.masonry();
    },

    methods: {

        masonry() {

            this._masonry = new Masonry(this.$refs.masonry, {
                itemSelector: ".grid-item",
                columnWidth: ".grid-sizer",
                horizontalOrder: true,
                percentPosition: true
            });
        },

        getColumnWidth() {
            let width = 560;

            let wrapper = document.getElementById('wall');

            if (wrapper) {
                let wrapperWidth = wrapper.offsetWidth;

                switch (this.currentBreakpoint) {
                    case "sm":
                        width = 264.5;
                        break;
                    case "md":
                        width = 360.5;
                        break;
                    case "lg":
                        width = 391; //395.05
                        break;
                    case "xl":
                        width = 318.5;
                        break;
                    case "xxl":
                        width = wrapperWidth / 3.1;
                        break;
                }
            }

            return width;
        },

        mirrorClicked(id) {

            document.getElementById('gallery_' + id).click();
        },

        getTargetId(id) {
            return "gallery_" + id;
        },

        onWindowResized(width) {
            let detectedBreakpoint = "sm";

            for (const [key, value] of Object.entries(this.breakpoints)) {

                if (width >= value) {
                    detectedBreakpoint = key;
                }
            }

            this.currentBreakpoint = detectedBreakpoint;

            /*this.$nextTick(() => {
                this.masonry();
            })*/
        },

        scroll() {
            window.onscroll = () => {

                const scrollable = document.documentElement.scrollHeight - (Utils.xy().y * 3);
                const scrolled = window.scrollY;

                let bottomOfWindow = false;
                if (Math.ceil(scrolled) >= scrollable) {
                    bottomOfWindow = true;
                }

                if (bottomOfWindow && this.shouldLoadItems && !this.loading) {
                    this.loadItems(this.page);
                }
            }
        },

        loadItems(page) {
            this.loading = true;

            const conf = {
                params: {
                    page: page,
                    thumbnail: ["1080p", "720p"],
                }
            };

            this.axios.get(`${BASE_URL}/api/items/${this.author.id}`, conf)
                .then(response => {

                    const newItems = response.data.data;
                    newItems.sort((a, b) => a.position - b.position);

                    this.items = [...this.items, ...newItems];

                    this.items.sort((a, b) => a.position - b.position);

                    /*for (const item of this.items) {
                        console.log(`[ID - POSITION] : [${item.id} - ${item.position}]`);
                    }*/

                    this.meta = response.data.meta;
                    Fancybox.bind('[data-fancybox="gallery"]')

                }).catch(error => {

            }).finally(() => this.loading = false);
        },

    },

    computed: {
        page() {

            if (this.meta == null) {
                return 1;
            } else {
                const current_page = this.meta.current_page;
                const last_page = this.meta.last_page;

                if (current_page < last_page) {
                    return current_page + 1;
                } else {
                    return last_page;
                }
            }
        },

        shouldLoadItems() {

            let ret_val = true;

            if (this.meta != null) {
                const current_page = this.meta.current_page;
                const last_page = this.meta.last_page;

                ret_val = current_page < last_page;
            }

            return ret_val;
        },

        columnWidth() {

            let width = 560;

            let wrapper = document.getElementById('wall');
            let wrapperWidth = wrapper.offsetWidth;

            switch (this.currentBreakpoint) {
                case "sm":
                    width = 264.5;
                    break;
                case "md":
                    width = 360.5;
                    break;
                case "lg":
                    width = 391; //395.05
                    break;
                case "xl":
                    width = 318.5;
                    break;
                case "xxl":
                    width = wrapperWidth / 3.1;
                    break;
            }

            return width;
        }
    },

    watch: {

        currentBreakpoint(newVal, oldVal) {

            //console.log("breakpoint changed: " + oldVal + " -> " + newVal);

        },

        items(newVal, oldVal) {

            //console.log("items changed");

            /*this.masonry();*/

        }
    }
}
</script>

<style scoped>

.nx-item {
    overflow: hidden;
    width: 100%;
}

.nx-content {
    padding: 20px;
}

img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
}

.grid-item,
.grid-sizer {
    width: calc(100% - 32px);
    margin-bottom: 32px;
    margin-left: 16px;
    margin-right: 16px;
}

/*
breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1586,
},
*/


@media(min-width: 768px){

    .grid-item,
    .grid-sizer {
        width: calc(50% - 32px);
    }
}

@media(min-width: 1200px){

    .grid-item,
    .grid-sizer {
        width: calc(33.333% - 32px);
    }
}

/*@media(min-width: 1586px){

    .grid-item,
    .grid-sizer {
        width: 33.333%;
    }
}*/



</style>
